module.exports = __webpack_public_path__ + "static/media/Img_5.1c98acba.JPG";